import * as React from 'react';
import { UIHeading2, ArticleParagraph2 } from '@cian/ui-kit';

import cn from 'clsx';

import { Table, programs } from './components/Table';
import { AccordionsBlock, mortgageInformationAccordions, socialPaymentsAccordions } from './components/AccardionsBlock';

import * as styles from './styles.css';

export const InformationalSeoBlock: React.FC = () => {
  return (
    <div className={styles['root']}>
      <div className={cn(styles['border-wrapper'], styles['mb16'])}>
        <div className={styles['title']}>
          <UIHeading2>Ипотека 2024</UIHeading2>
        </div>
        <ArticleParagraph2>
          Ипотека — вид кредита, когда банк выдает деньги под залог недвижимости. В случае покупки квартиры в ипотеку
          право собственности оформляется на заёмщика, при этом недвижимость остается в залоге у банка до полного
          погашения долга. Это накладывает ограничения на собственника — например, продать ипотечную квартиру можно
          только с согласия банка.
        </ArticleParagraph2>
      </div>
      <div className={cn(styles['border-wrapper'], styles['mb16'])}>
        <div className={styles['title']}>
          <UIHeading2>Условия получения</UIHeading2>
        </div>
        <div className={styles['mb16']}>
          <div>
            <ArticleParagraph2>Существует ряд общих требований банков к заёмщикам:</ArticleParagraph2>
            <ul className={styles['list']}>
              <li>
                <ArticleParagraph2>Прописка в любом регионе РФ;</ArticleParagraph2>
              </li>
              <li>
                <ArticleParagraph2>
                  Возраст от 21 года на момент одобрения ипотеки, и до 65 лет на момент окончания платежей;
                </ArticleParagraph2>
              </li>
              <li>
                <ArticleParagraph2>Подтверждённый стабильный доход;</ArticleParagraph2>
              </li>
              <li>
                <ArticleParagraph2>Стаж на текущем месте работы от 3-6 месяцев.</ArticleParagraph2>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['mb16']}>
          <div>
            <ArticleParagraph2>
              Стандартный пакет документов, который банки запрашивают для рассмотрения заявки на ипотеку:
            </ArticleParagraph2>
            <ul className={styles['list']}>
              <li>
                <ArticleParagraph2>Паспорт, ИНН, СНИЛС;</ArticleParagraph2>
              </li>
              <li>
                <ArticleParagraph2>Военный билет (для мужчин призывного возраста);</ArticleParagraph2>
              </li>
              <li>
                <ArticleParagraph2>Документы, подтверждающие доход.</ArticleParagraph2>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['mb16']}>
          <ArticleParagraph2>
            Чтобы увеличить вероятность одобрения кредита можно привлечь созаёмщика — тогда банк будет учитывать
            совокупный доход. В этом случае созаёмщику нужно будет собрать и предоставить тот же пакет документов.
          </ArticleParagraph2>
        </div>
        <div className={styles['mb16']}>
          <ArticleParagraph2>
            Банк может запросить дополнительные сведения, чтобы оценить финансовую нагрузку заёмщика. Например,
            документы, подтверждающие состав семьи, имеющееся имущество, дополнительные доходы и задолженности.
          </ArticleParagraph2>
        </div>
        <ArticleParagraph2>
          Для участия в льготных программах ипотечного кредитования потребуется подтвердить право на льготу. Для
          семейной ипотеки — предоставить документы о составе семьи, для IT-ипотеки — подтвердить работу в
          аккредитованной IT-компании, для сельской — соответствие объекта недвижимости требованиям программы.
        </ArticleParagraph2>
      </div>
      <div className={cn(styles['border-wrapper'], styles['mb16'])}>
        <div className={styles['title']}>
          <UIHeading2>Популярные банки для ипотеки в 2024</UIHeading2>
        </div>
        <div>
          <ul className={styles['list']}>
            <li>
              <ArticleParagraph2>СберБанк</ArticleParagraph2>
            </li>
            <li>
              <ArticleParagraph2>ВТБ</ArticleParagraph2>
            </li>
            <li>
              <ArticleParagraph2>Альфа-Банк</ArticleParagraph2>
            </li>
            <li>
              <ArticleParagraph2>Совкомбанк</ArticleParagraph2>
            </li>
            <li>
              <ArticleParagraph2>Банк ДОМ.РФ</ArticleParagraph2>
            </li>
          </ul>
        </div>
      </div>
      <div className={cn(styles['border-wrapper'], styles['mb16'])}>
        <div className={styles['title']}>
          <UIHeading2>Льготные программы ипотеки</UIHeading2>
        </div>
        <div className={styles['mb16']}>
          <ArticleParagraph2>
            В России существует несколько льготных программ ипотечного кредитования, которые помогают снизить финансовую
            нагрузку при покупке жилья. У каждой из них свои условия участия, но есть общее и обязательное для всех —
            наличие у заёмщика гражданства Российской Федерации.
          </ArticleParagraph2>
        </div>
        <div>
          <ArticleParagraph2>Программы можно условно разделить на две категории:</ArticleParagraph2>
          <ul className={styles['list']}>
            <li>
              <ArticleParagraph2>
                Ипотека с государственной поддержкой. Заёмщик может взять ипотеку по ставке значительно ниже рыночной, а
                разницу между установленной ставкой и рыночной банку компенсирует государство.
              </ArticleParagraph2>
            </li>
            <li>
              <ArticleParagraph2>
                Социальные выплаты, которые могут быть использованы либо в качестве первоначального взноса, либо на
                погашение ипотечного кредита.
              </ArticleParagraph2>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles['mb16']}>
        <Table title={programs.title} elements={programs.elements} />
      </div>
      <div className={styles['mb16']}>
        <AccordionsBlock title={socialPaymentsAccordions.title} elements={socialPaymentsAccordions.elements} />
      </div>
      <AccordionsBlock title={mortgageInformationAccordions.title} elements={mortgageInformationAccordions.elements} />
    </div>
  );
};
